<template>
  <auth-layout pageClass="register-page">
    <div class="row d-flex justify-content-center">
      <div class="col-md-8">
        <div class="header-text">
          <img class="customLogoCP" src="/static/img/CPG-logowhite-tagline.svg" alt="avatar"/>
          <h4>Welcome to Century Properties!</h4>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12 mx-auto">

        <card v-if="step==='one'">
            <form @submit.prevent="submit()">
              <fg-input  type="text"
                          label="Name"
                          name="Name"
                          v-model="det.name">
              </fg-input>                                   
              <small v-if="required.name === 1" class="required">*Name is required</small>    

              <fg-input  type="text"
                          label="Mobile Number"
                          name="mobilenumber"
                          >
              <VuePhoneNumberInput name="Mobile" v-model="det.mobilenumber" default-country-code="PH" :only-countries="['PH']" :translations="this.translations"/>             
              </fg-input>  
              <small v-if="required.mobilenumber === 1" class="required">*Mobile Number is required and must be valid</small>

              <div class="d-flex justify-content-center p-4">
                <button type="submit" class="btn btn-fill btn-cp btn-wd">Submit</button>
              </div>

            </form>
        </card>

        <card v-else-if="step === 'two'">
            <div class="d-flex justify-content-center">
              <img class="customLogoSmall" src="/static/img/otp.png" alt="avatar"/>
            </div>

            <div class="d-flex justify-content-center">
              <p>We've sent a One Time Password (OTP) to your mobile number. Please enter it to complete verification</p>
            </div>

            <div class="d-flex justify-content-center p-2">
              <PincodeInput
                v-model="det.otp"
                :length=6
              />
            </div>

            <div class="d-flex justify-content-center p-4">
              <button type="submit" :disabled="resendDisabled" class="btn btn-fill btn-cp btn-wd m-2" @click="resendOTP()">Resend OTP</button>
              <button type="submit" class="btn btn-fill btn-cp btn-wd m-2" @click="submitOTP()">Verify</button>
            </div>

            <div class="d-flex justify-content-center">
              <h6>Resend in: {{ minutes }}m {{ seconds }}s</h6>
            </div>

        </card>

        <card v-else-if="step === 'three'">
          <div class="d-flex justify-content-center">
            <img class="customLogoSmall" src="/static/img/check2.webp" alt="avatar"/>
          </div>
          <div class="d-flex justify-content-center">
            <h5>Verification Successful!</h5>
          </div>          
          <div class="d-flex justify-content-center">
            <h5>Please wait while we</h5>
          </div>
          <div class="d-flex justify-content-center">
            <h5>connect you to our network!</h5>
          </div>
        </card>
        
      </div>
      
      <div class="col-md-8">
        <div class="d-flex justify-content-center footer">
          <small>Powered by <img class="customLogoSmall" src="/static/img/iwave.png" alt="avatar"/></small>
        </div>
      </div>      
    </div>


    <div v-if="showModal" class="modal">
      <card class="col-lg-6 col-md-12 col-sm-12 m-2">
        
        <div class="scroll-card">
          <div class="d-flex justify-content-center">
            <h5>We value your privacy</h5>
          </div>

          <div class="d-flex justify-content-center">
            <p>
              These terms and conditions outline the rules and regulations for the use of this Website.
            </p>
          </div>

          <div class="d-flex justify-content-center">
            <p>By accessing this website we assume you accept these terms and conditions in full. Do not continue to use this website if you do not accept all of the terms and conditions stated on this page.</p>
          </div>

          <div class="d-flex justify-content-center">
            <p>The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and any or all Agreements: “Client”, “You” and “Your” refers to you, the person accessing this website and accepting the Company’s terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and ourselves, or either the Client or ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner, whether by formal meetings of a fixed duration, or any other means, for the express purpose of meeting the Client’s needs in respect of provision of the Company’s stated services/products, in accordance with and subject to, prevailing law of . Any use of the above terminology or other words in the singular, plural, capitalisation and/or he/she or they, are taken as interchangeable and therefore as referring to same.</p>
          </div>
          
          <div class="d-flex justify-content-center">
            <h5>Cookies</h5>
          </div>

          <div class="d-flex justify-content-center">
            <p>We employ the use of cookies. By using this website you consent to the use of cookies in accordance with this website's privacy policy.</p>
          </div>

          <div class="d-flex justify-content-center">
            <p>Most of the modern day interactive web sites use cookies to enable us to retrieve user details for each visit. Cookies are used in some areas of our site to enable the functionality of this area and ease of use for those people visiting. Some of our affiliate / advertising partners may also use cookies.</p>
          </div>

          <div class="d-flex justify-content-center">
            <h5>License</h5>
          </div>

          <div class="d-flex justify-content-center">
            <p>Unless otherwise stated, this website and/or it's licensors own the intellectual property rights for all material on this website. All intellectual property rights are reserved.</p>
          </div>

          <div class="d-flex justify-content-center">
            <p>Redistribute content from this website (unless content is specifically made for redistribution).</p>
          </div>

          <div class="d-flex justify-content-center">
            <h5>Reservation of Rights</h5>
          </div>

          <div class="d-flex justify-content-center">
            <p>We reserve the right at any time and in its sole discretion to request that you remove all links or any particular link to our Web site. You agree to immediately remove all links to our Web site upon such request. We also reserve the right to amend these terms and conditions and its linking policy at any time. By continuing to link to our Web site, you agree to be bound to and abide by these linking terms and conditions.</p>
          </div>
          
          <div class="d-flex justify-content-center">
            <h5>Removal of links from our website</h5>
          </div>

          <div class="d-flex justify-content-center">
            <p>If you find any link on our Web site or any linked web site objectionable for any reason, you may contact us about this. We will consider requests to remove links but will have no obligation to do so or to respond directly to you.</p>
          </div>
          
          <div class="d-flex justify-content-center">
            <p>Whilst we endeavour to ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we commit to ensuring that the website remains available or that the material on the website is kept up to date.</p>
          </div>

          <div class="d-flex justify-content-center">
            <h5>Content Liability</h5>
          </div>
          
          <div class="d-flex justify-content-center">
            <p>We shall have no responsibility or liability for any content appearing on your Web site. You agree to indemnify and defend us against all claims arising out of or based upon your Website. No link(s) may appear on any page on your Web site or within any context containing content or materials that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.</p>
          </div>

          <div class="d-flex justify-content-center">
            <h5>Disclaimer</h5>
          </div>

          <div class="d-flex justify-content-center">
            <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website (including, without limitation, any warranties implied by law in respect of satisfactory quality, fitness for purpose and/or the use of reasonable care and skill). Nothing in this disclaimer will:</p>
          </div>

          <div class="d-flex justify-content-center">
            <ul>
              <li>limit or exclude our or your liability for death or personal injury resulting from negligence;</li>
              <li>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
              <li>limit any of our or your liabilities in any way that is not permitted under applicable law; or</li>
              <li>exclude any of our or your liabilities that may not be excluded under applicable law.</li>
            </ul>
          </div>

          <div class="d-flex justify-content-center">
            <p>The limitations and exclusions of liability set out in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer or in relation to the subject matter of this disclaimer, including liabilities arising in contract, in tort (including negligence) and for breach of statutory duty.</p>
          </div>

          <div class="d-flex justify-content-center">
            <p>To the extent that the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.</p>
          </div>

        </div>

        <div class="d-flex justify-content-center">
            <button type="submit" class="btn btn-fill btn-cp btn-wd m-2" @click="closeModal()">Accept All</button>
        </div>
      </card>
    </div>
  </auth-layout>
</template>
<script>
  import AuthLayout from './AuthLayout.vue'
  import PincodeInput from 'vue-pincode-input';

  import VuePhoneNumberInput from 'vue-phone-number-input';
  import 'vue-phone-number-input/dist/vue-phone-number-input.css';

  import swal from 'sweetalert2';

  import { FadeRenderTransition } from 'src/components/index';
  import { md5 } from 'js-md5';

  export default {
    components: {
      AuthLayout,
      PincodeInput,
      VuePhoneNumberInput
    },
     data () {
      return {
        hex: this.$route.params.id,
        required: {
          name: 0,
          mobilenumber: 0
        },
        det: {
          name: "",
          mobilenumber: "",
          otp: "",
          identifier: "WEBDEMO" 
        },
        step: 'one',
        otp: "",
        remainingTime: 60 * 5,
        timerInterval: null,
        resendDisabled: true,
        translations: {
          phoneNumberLabel: '',
        },
        showModal: false,
        //url: "http://localhost:3060",
        url: "https://mikrotik2-api.iwar.com.ph/",        
        mikro: {
          id: "",
          mac: "",
          ip: "",
          username: "",
          linkLogin: "",
          linkloginonly: "",
          test: "",
          linkorig: "",
        },
        username: 'admin',
        password: '',
      }
    },
    watch: {
      remainingTime(newVal) {
        if (newVal <= 0) {
          this.clearInterval();
        }
      },
    },
    mounted() {
      this.openModal(); // Call the method to open the modal on component mount
      //this.getParam();
    },
    methods: {
      async getParam() {
        const data = {
          "hex" : this.hex
        };

        this.axios.post(this.url + "/mw-data", data)
              .then( res => {
                var res = res;
                console.log(res.data)       
                this.mikro.mac = res.data.mac;
                this.mikro.ip = res.data.ip;
                this.mikro.linkLogin = res.data.linklogin
                this.mikro.linkloginonly = res.data.linkloginonly
                this.mikro.linkorig = res.data.linkorig
                
                console.log(this.mikro)
                //this.tryLogin();
              }).catch(err => {
                //swal.fire(err, "", "info");
              })

      },
      async tryLogin() {

        //const url = this.mikro.linkloginonly;
        const url = "https://mikrotik1.iwar.com.ph/connect2.php";

          const form = document.createElement('form');
          form.method = 'POST';
          form.action = url;

          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'link-login-only';
          input.value = JSON.stringify(this.mikro.linkloginonly);
          
          const input2 = document.createElement('input');
          input2.type = 'hidden';
          input2.name = 'link-orig';
          input2.value = JSON.stringify(this.mikro.linkorig);

          form.appendChild(input);
          form.appendChild(input2);
          document.body.appendChild(form);
          form.submit();

        //fetch

      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      async submit() { 

        if (this.det.name == "") {
          this.required.name = 1;
        } else {
          this.required.name = 0;
        }

        if (this.det.mobilenumber.length < 9) {
          this.required.mobilenumber = 1;
        } else {
          this.required.mobilenumber = 0;
        }

        if ((this.required.name == 0) && (this.required.mobilenumber == 0)) {
          //api here
              this.axios.post(this.url + "/sl/register", this.det)
              .then( res => {
                var res = res;
                //console.log(res)
                if (res.data.status) {
                  this.step = "two";
                  this.startTimer();                  
                } else {
                  swal.fire(res.data.message, "", "info");
                }                                
              }).catch(err => {
                swal.fire(err, "", "info");
              })
        }

      },
      async startTimer() {
        //this.resendDisabled = true;
        this.timerInterval = setInterval(() => {
          if (this.remainingTime > 0) {
            this.remainingTime--;
          } else {
            this.resendDisabled = false;
            this.clearTimer();
          }
        }, 1000);
      },
      async clearTimer() {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      },
      async resendOTP() {
        // Implement resend code logic here
        //api here check otp
        this.axios.post(this.url + "/sl/request-new-otp", this.det)
              .then( res => {
                
          if (this.remainingTime <= 0) {
            swal.fire("OTP resent!", "", "info");
            // Reset timer
            this.remainingTime = 60 * 5;
            this.resendDisabled = false;
            this.startTimer();
          }
                
        }).catch(err => {
  
        })
        
      },

      async submitOTP() {

        //api here check otp
        this.axios.post(this.url + "/sl/verify-otp", this.det)
              .then( res => {
                var res = res;
                if (res.data.status) {
                  this.step = "three";
                  //doLogin
                    this.getParam();
                  //doLogin

                } else {
                  swal.fire(res.data.message, "", "info");
                } 
        }).catch(err => {
  
        })

      },     
      //modal
      openModal() {
        this.showModal = true;
      },
      closeModal() {
        this.showModal = false;
      },
      //modal
    },
    beforeDestroy () {
      this.closeMenu()
    },
    computed: {
      minutes() {
        return Math.floor(this.remainingTime / 60);
      },
      seconds() {
        return this.remainingTime % 60;
      },
    },
  }
</script>
<style scoped>

.customLogoCP {
  width: 200px
}

.customLogoSmall {
  width: 60px;
}

.btn-cp {
    border: 1px solid #3d7f76;
    color: #FFFFFF;
    background-color: #3d7f76;
    cursor: pointer;
}

.required {
  margin-top: -20px;
  margin-bottom: 20px;
  display: block;
  color: #FB404B !important;
  font-size: 0.7rem;
  font-style:italic;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  margin: 0 auto;
  background-color: white;
  padding: 20px;
}

.scroll-card {
  overflow-y: scroll;
  height: 35vh;
}

</style>
